import { z } from 'zod';

export const WafCheckQuerySchema = z.object({
  url: z.string().min(1).describe('URL to check for WAF presence'),
});

export const WafCheckResultSchema = z.object({
  wafDetected: z.boolean().optional().describe('Whether a WAF was detected'),
  urlReachable: z
    .boolean()
    .optional()
    .describe('Whether the URL was reachable'),
  untrustedCertificate: z
    .boolean()
    .optional()
    .describe(
      'URL was reachable only after skipping TLS certificate verification',
    ),
  error: z.string().optional().describe('Error message if the check failed'),
});
